import { render } from "react-dom";
import Hexfill from "./pages/hexfill";

const appElement = document.getElementById("app");

render(
    <Hexfill />,
    appElement
);